import { urlConfig } from "../../config/urlConfig";
import { postCall, postFileDownloadCall } from "../httpService";

const getFieldsOfReports = urlConfig.GetFieldsOfReports;
const SaveQuery = urlConfig.SaveQuery;
const GetSavedQuery = urlConfig.GetSavedQuery;
const Schedule = urlConfig.Schedule;
const GetSavedQueryDetails = urlConfig.GetSavedQueryDetails;
const FileInfoReports = urlConfig.FileInfoReports;
const Useractivity = urlConfig.Useractivity
const UpdateQueryReport = urlConfig.UpdateQueryReport;

export const getFields = async (params: any) => {
  try {
    const response = await postCall(getFieldsOfReports, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const createQuery = async (params: any) => {
  try {
    const response = await postCall(SaveQuery, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getSaveQuery = async (params: any) => {
  try {
    const response = await postCall(GetSavedQuery, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const createScheduleQuery = async (params: any) => {
  try {
    const response = await postCall(Schedule, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getsavedQueryDetails = async (params: any) => {
  try {
    const response = await postCall(GetSavedQueryDetails, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const generateReport = async (params: any) => {
    try {
        const response = await postFileDownloadCall(FileInfoReports, params);
        return response.data;
    } catch (error) {
        console.log("Error in DownloadEmailTemplate ", error);
        throw error;
    }
};

export const userActivity = async (params: any) => {
  try {
    const response = await postCall(Useractivity, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const updateQueryReport = async (params: any) => {
  try {
    const response = await postCall(UpdateQueryReport, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
